(function () {
  var COLOR_MAP = {
    blanco: '#ffffff',
    negro: '#0a0a0a',
    gris: '#9ca3af',
    'gris vigoré': '#9ca3af',
    'gris oscuro': '#4b5563',
    'gris claro': '#d1d5db',
    marino: '#1e3a5f',
    royal: '#1d4ed8',
    morado: '#7c3aed',
    verde: '#16a34a',
    crudo: '#f1e7d6',
    rojo: '#dc2626',
    amarillo: '#facc15',
  };

  function colorFor(name) {
    return COLOR_MAP[name.trim().toLowerCase()] || null;
  }

  function swatchStyle(value) {
    var parts = value.split('/').map(function (p) { return p.trim(); });
    if (parts.length === 2) {
      var c1 = colorFor(parts[0]);
      var c2 = colorFor(parts[1]);
      if (c1 && c2) return 'background: linear-gradient(90deg, ' + c1 + ' 50%, ' + c2 + ' 50%);';
      return null;
    }
    var c = colorFor(value);
    return c ? 'background: ' + c + ';' : null;
  }

  function applySwatches(root) {
    root.querySelectorAll('.product-form__input--pill').forEach(function (fieldset) {
      var legend = fieldset.querySelector('.form__label');
      if (!legend || legend.textContent.trim().toLowerCase() !== 'color') return;
      fieldset.querySelectorAll('label').forEach(function (label) {
        if (label.querySelector('.estampal-swatch-dot')) return;
        var input = document.getElementById(label.getAttribute('for'));
        if (!input) return;
        var style = swatchStyle(input.value);
        if (!style) return;
        var dot = document.createElement('span');
        dot.className = 'estampal-swatch-dot';
        dot.setAttribute('style', style);
        label.prepend(dot);
        fieldset.classList.add('has-color-swatches');
      });
    });
  }

  function init() {
    // Dawn's variant-picker updates via a view-transition that replaces the whole
    // <variant-selects> node on change, so a MutationObserver on that node itself
    // gets orphaned. Observe the stable <product-info> ancestor instead.
    document.querySelectorAll('product-info').forEach(function (el) {
      applySwatches(el);
      var observer = new MutationObserver(function () { applySwatches(el); });
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
